import React from "react";

const Hero = () => {
  return (
    <div id="hero" className="w-full px-20px max-w-[1130px] xl:mt-[230px] lg:mt-[190px] mt-[150px] mx-auto">
      <p className="text-center xl:text-[34px] xl:leading-[54.4px] lg:text-[30px] lg:leading-[36px] text-[24px] leading-[32px] font-fira">
        <span className="font-bold text-customRed">FIRED UP TO VOTE </span> 
        <span className="font-normal text-black">
            is the ONLY friend-to-friend get out the vote software tool that empowers common-sense, engaged citizens in 
          Harris County to educate and activate their personal networks and spheres of influence to VOTE and increase overall voter turnout.
          Fired Up To Vote also provides a UNIQUE accountability tool allowing users to know if their networks have voted.
        </span>
      </p>
    </div>
  );
};

export default Hero;